import {
  ClampJointAdditionalMaterial,
  ClampJointCountSettings,
  ClampJointTypeEnum,
} from '../../user/cutting-settings.model';
import { ICuttingBaseMaterial } from '../cutting-base-material.model';
import { CuttingButt } from '../cutting-butt.model';
import { CuttingCustomHole } from '../cutting-custom-hole.model';
import { CuttingFixedFastenersSet } from '../cutting-fixed-fasteners-set.model';
import { CuttingMaterial } from '../cutting-material.model';
import { GrooveTypeEnum } from '../cutting-panel-base-slot.model';
import { AngleMode, Cutout, FaceBand, MasonsMitreOrientationEnum, PlateTypeEnum } from '../cutting-panel-outline.model';
import { CountertopLinesJointTypeEnum, CountertopTypeEnum } from './countertop.interface';

export interface CountertopResponse {
  id: number;
  has3d: boolean;
  useClampJointForPanels: boolean;
  type: CountertopTypeEnum;
  subtype: number | null;
  materials: CuttingMaterial[];
  length: number;
  width: number;
  lines: CountertopLineResponse[];
  linesJoints: CountertopLinesJointResponse[];
  outline: CountertopOutlineResponse;
}

export interface CountertopLineResponse {
  uid: string;
  materialId: number;
  panels: CountertopPanelResponse[];
  length: number;
  width: number;
  panelsJoints: CountertopPanelsJointResponse[];
}

export interface CountertopPanelsJointResponse {
  panel1Uid: string;
  panel2Uid: string;
  connector: ClampJointResponse | null;
}

export interface CountertopPanelResponse {
  uid: string;
  length: number;
  width: number;
}

export interface CountertopLinesJointResponse {
  line1Uid: string;
  line2Uid: string;
  line1Type: CountertopJointLineTypeResponseEnum;
  line2Type: CountertopJointLineTypeResponseEnum;
  type: CountertopLinesJointTypeEnum;
  length: number;
  parameters: MasonsMitreJointParamsResponse | null;
  connector: ClampJointResponse | null;
}

export interface MasonsMitreJointParamsResponse {
  radius: number;
  allowance: number;
}

// OUTLINE

export interface CountertopOutlineResponse {
  customHoles: CountertopHoleResponse[];
  fastenersSets: CountertopFastenersSetResponse[];
  angleProcessing: CountertopAngleProcessingResponse[];
  edgeBanding: CountertopEdgeBandingResponse[];
  faceBanding: FaceBand[];
  slots: CountertopSlotResponse[];
  cutouts: Cutout[];
}

export interface CountertopFastenersSetResponse extends CuttingFixedFastenersSet {
  position: CountertopOutlineSideResponseEnum;
}

export interface CountertopHoleResponse extends CuttingCustomHole {
  position: CountertopOutlineSideResponseEnum;
}

export interface CountertopAngleProcessingResponse {
  mode: AngleMode;
  angleNumber: number;
  parameters: AngleProcessingParamsResponse;
}

export interface AngleProcessingParamsResponse {
  r: number | null;
  x: number | null;
  y: number | null;
  yA: number | null;
  xA: number | null;
  y1: number | null;
  x1: number | null;
  length: number | null;
  allowance: number | null;
  orientation: MasonsMitreOrientationEnum | null;
  edgeBanding: CuttingButt;
}

export interface CountertopEdgeBandingResponse extends ICuttingBaseMaterial {
  id: number;
  sideNumber: number;
  groupId: number;
  name: string;
  article: string;
  sign: string;
  thickness: number;
  overhang: number;
  textureName: string;
  textureRotationDegree: number;
  color: string;
  allowance: number;
  width: number;
  isTape: boolean;
  measureName: string;
  price: number;
  weightPerItem: number;
  textureLink: string;
  cropTextureLink: string;
  quantityInStock: number;
}

export class CountertopSlotResponse {
  id: number;
  sideNumber: number;
  name: string;
  designation: string;
  type: GrooveTypeEnum;
  custom: boolean;
  plate: PlateTypeEnum;
  parameters?: CountertopSlotParamsResponse;
}

export interface CountertopSlotParamsResponse {
  r: number | null;
  fi: number | null;
  dx: number | null;
  b: number | null;
  h: number | null;
  g: number | null;
}

export interface ClampJointResponse {
  type: ClampJointTypeEnum;
  l: number;
  l2: number;
  h: number;
  b: number;
  d: number;
  additionalMaterials: ClampJointAdditionalMaterial[];
  minMaterialThickness: number;
  maxMaterialThickness: number;
  edgeOffset: number;
  countSettings: ClampJointCountSettings[];
  count: number;
  nameOfGrooveRecess: string;
  designationOfGrooveRecess: string;
}

export enum CountertopJointLineTypeResponseEnum {
  None,
  Male,
  Female,
}

export enum CountertopOutlineSideResponseEnum {
  Top,
  Right,
  Bottom,
  Left,
}
